module.exports = __webpack_public_path__ + "img/img_nav_lang-w.7c68fa4a.svg";